@use '@design/design-tokens/typography/typography' as *;

.root {
  position: absolute;
  inset: 0;
  z-index: 3;
  pointer-events: none;
}

.insight {
  position: absolute;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column-reverse;
  gap: 4px;
  align-items: center;
  pointer-events: none;
}

.icon {
  pointer-events: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.zoomIntoViewText {
  position: absolute;
  bottom: 28px;
  left: 50%;
  transform: translateX(-50%);
  color: var(--text-soft);
  @include typography-v2-body-sm;
}
